import { render, staticRenderFns } from "./PaymentWithOnePay.vue?vue&type=template&id=0566eed5"
import script from "./PaymentWithOnePay.vue?vue&type=script&lang=js"
export * from "./PaymentWithOnePay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports